export const STICKY_READY_CLASS = 'header__sticky-ready'
export const STICKY_SHOW_CLASS = 'header__sticky-show'
